let trackerLoading = null

// 只在用户同意后加载录制脚本，预览阶段不启用 SDK 自带的默认上传地址。
function loadTracker() {
  if (window.WebRecord) return Promise.resolve()
  if (trackerLoading) return trackerLoading
  trackerLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const timeout = setTimeout(() => finish(new Error('录制脚本加载超时')), 15000)
    function finish(error) {
      clearTimeout(timeout)
      script.onload = null
      script.onerror = null
      if (error) {
        script.remove()
        trackerLoading = null
        reject(error)
      } else resolve()
    }
    script.src = `${process.env.BASE_URL}js/tracker.min.js`
    script.onload = () => finish(window.WebRecord ? null : new Error('录制脚本不可用'))
    script.onerror = () => finish(new Error('录制脚本加载失败'))
    document.head.appendChild(script)
  })
  return trackerLoading
}

export async function createInsuranceRecorder(onStop) {
  await loadTracker()
  // 脱敏覆盖输入框和标记的展示文本；协议和投保接口确认前仅保留内存中的回放事件。
  return new window.WebRecord({
    autoStart: false,
    recordOptions: {
      maskAllInputs: true,
      maskTextClass: 'insurance-private',
      recordCanvas: false,
      recordCrossOriginIframes: false,
    },
    onStop,
  })
}

let resultRecorder = null
let resultStopTimer = null

export function stopResultRecording() {
  clearTimeout(resultStopTimer)
  resultStopTimer = null
  window.removeEventListener('pagehide', stopResultRecording)
  const recorder = resultRecorder
  resultRecorder = null
  if (recorder && recorder.isRecording) recorder.stop()
}

export function handoffResultRecording(recorder) {
  stopResultRecording()
  resultRecorder = recorder
  if (!recorder) return
  // 站内路由切换保留实例，由结果区块首帧展示后停录；离站或加载失败仍会收尾，避免持续后台采集。
  window.addEventListener('pagehide', stopResultRecording, { once: true })
  resultStopTimer = setTimeout(stopResultRecording, 30000)
}
